import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useIdentity } from '@zenbusiness/application-commons-identity';

export const EDUCATION_STUDIO_GET_LESSONS = gql`
  query lessons($accountUuid: UUID!) {
    lessons(accountUuid: $accountUuid) {
      id
      name
      isCompleted
      completedArticles
      totalArticles
      articles {
        name
        path
        isCompleted
      }
    }
  }
`;

export default function useLessonsQuery() {
  const { accountUuid } = useIdentity();

  return useQuery(EDUCATION_STUDIO_GET_LESSONS, {
    variables: {
      accountUuid
    }
  });
}
